module.exports = __webpack_public_path__ + "img/asanbazar_ss.729bb395.png";